/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface ProviderIntegrationViewModel {
  /**
   * Provider Id (not used for Add)
   */
  id?: string | null;
  /**
   * Provider Code
   */
  providerCode?: string | null;
  /**
   * Provider Last Name, maximum length 50
   */
  lastName?: string | null;
  /**
   * Provider First Name, maximum length 50
   */
  middleName?: string | null;
  /**
   * Provider Middle Name, maximum length 50
   */
  firstName?: string | null;
  /**
   * Provider Title, maximum length 100
   */
  title?: string | null;
  /**
   * Provider NPI, max length 20
   */
  npi?: string | null;
  /**
   * Provider tax id number, max length 20
   */
  taxId?: string | null;
  /**
   * Provider Taxonomy code. Max length 100
   */
  taxonomy?: string | null;
  /**
   * This option is true if the provider is an Attending Provider for the practice.
   */
  isBillable?: boolean | null;
}
